/*
 * collection-filters.js
 * Drawer mobil pentru filtrele native de colectie. Pe desktop sidebar-ul e
 * static; pe mobile butonul "Filtre" deschide un panou off-canvas.
 */
(function () {
  'use strict';

  function init() {
    var drawer = document.querySelector('[data-filters-drawer]');
    var openBtn = document.querySelector('[data-filters-open]');
    var closeBtn = document.querySelector('[data-filters-close]');
    var overlay = document.querySelector('[data-filters-overlay]');
    if (!drawer || !openBtn) return;

    function open() {
      drawer.classList.add('is-open');
      if (overlay) overlay.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
